import $ from 'jquery';
import product from '@wc-stripe/product'
import {toCents} from '@wc-stripe/utils';

$(window).on('tcEpoAfterCalculateTotals', (obj, data) => {
    setTimeout(() => {
        const {totalsObject} = data;
        const {product_total_price} = totalsObject;
        const update = {total: product_total_price};
        const lineItem = product.getLineItem();
        if (lineItem) {
            update.lineItems = product.getLineItems().map(item =>
                item.id === lineItem.id
                    ? {...item, amount: product_total_price, amountCents: toCents(product_total_price)}
                    : item
            );
        }
        product.update(update);
    }, 0);
})